import { saveAs } from "file-saver";

const BASE64_CHUNK_SIZE = 0x8000;

export const bytesOf = (base64) =>
  Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));

export const base64Of = (bytes) => {
  let binary = "";
  for (let offset = 0; offset < bytes.length; offset += BASE64_CHUNK_SIZE)
    binary += String.fromCharCode(
      ...bytes.subarray(offset, offset + BASE64_CHUNK_SIZE),
    );
  return btoa(binary);
};

export const readBytes = (file) =>
  file.arrayBuffer().then((buffer) => new Uint8Array(buffer));

export const saveBytes = (bytes, name) => saveAs(new Blob([bytes]), name);
